<script setup>
import AgentSettingCard from './AgentSettingCard.vue';
import IntersectionObserver from 'dashboard/components/IntersectionObserver.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import { ref } from 'vue';

const props = defineProps({
  agents: { type: Array, required: true },
  isLoadingMore: { type: Boolean, default: false },
  hasMore: { type: Boolean, default: true },
  showEditAction: { type: Function, required: true },
  showDeleteAction: { type: Function, required: true },
  loading: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['edit', 'delete', 'loadMore']);

const scrollEl = ref(null);

const intersectionObserverOptions = {
  root: scrollEl,            
  rootMargin: '0px',
  threshold: 0.2,
};
</script>

<template>
  <div ref="scrollEl" class="h-[calc(100dvh-280px)] overflow-y-auto scrollbar-none pb-24 md:pb-32">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <AgentSettingCard
        v-for="agent in agents"
        :key="agent.email"
        :agent="agent"
        :show-edit-action="showEditAction"
        :show-delete-action="showDeleteAction"
        :loading="loading"
        @edit="$emit('edit', $event)"
        @delete="$emit('delete', $event)"
      />
    </div>

    <div v-if="isLoadingMore" class="flex items-center justify-center py-4">
      <div class="flex items-center gap-2 text-sm text-slate-500">
        <Spinner />
        <span>Đang tải thêm...</span>
      </div>
    </div>

    <div v-else-if="!hasMore && agents.length > 0" class="p-4 text-center text-slate-400 dark:text-slate-300">
      Không còn agent nào để tải
    </div>

    <IntersectionObserver
      v-else
      :options="intersectionObserverOptions"
      @observed="$emit('loadMore')"
    />
  </div>
</template>

<style scoped>
.scrollbar-none { -ms-overflow-style: none; scrollbar-width: none; }
.scrollbar-none::-webkit-scrollbar { display: none; }
</style>